// ------------------------------------------------------------------------------------------
// @ Sale Actions
// ------------------------------------------------------------------------------------------

import { createAction, props } from '@ngrx/store';
import { Consistencies } from './sales.models';

// Load all Sales
export const loadSales = createAction('[Sale] Load Sales');
export const loadSalesSuccess = createAction(
    '[Sale] Load Sales Success',
    props<{ sales: any[] }>()
);
export const loadSalesFailure = createAction(
    '[Sale] Load Sales Failure',
    props<{ error: string }>()
);

// Load single Sale
export const loadSale = createAction(
    '[Sale] Load Sale',
    props<{ id: number }>()
);
export const loadSaleSuccess = createAction(
    '[Sale] Load Sale Success',
    props<{ sale: any }>()
);
export const loadSaleFailure = createAction(
    '[Sale] Load Sale Failure',
    props<{ error: string }>()
);

// Create
export const createSale = createAction(
    '[Sale] Create Sale',
    props<{ data: string }>()
);
export const createSaleSuccess = createAction(
    '[Sale] Create Sale Success',
    props<{ sale: any; success: string }>()
);
export const createSaleFailure = createAction(
    '[Sale] Create Sale Failure',
    props<{ error: string }>()
);

// Update
export const updateSale = createAction(
    '[Sale] Update Sale',
    props<{ data: string; id: number }>()
);
export const updateSaleSuccess = createAction(
    '[Sale] Update Sale Success',
    props<{ sale: any; success: string }>()
);
export const updateSaleFailure = createAction(
    '[Sale] Update Sale Failure',
    props<{ error: string }>()
);

// Delete
export const deleteSale = createAction(
    '[Sale] Delete Sale',
    props<{ id: number }>()
);
export const deleteSaleSuccess = createAction(
    '[Sale] Delete Sale Success',
    props<{ id: number; success: string }>()
);
export const deleteSaleFailure = createAction(
    '[Sale] Delete Sale Failure',
    props<{ error: string }>()
);

// Consistency Validation
// export const validateSalesConsistency = createAction(
//     '[Sale] Validate Sales Consistency',
//     props<{ totalGross: number }>()
// );
export const validateSalesConsistencySuccess = createAction(
    '[Sale] Validate Sales Consistency Success',
    props<{ consistencies: Consistencies }>()
);
export const validateSalesConsistencyFailure = createAction(
    '[Sale] Validate Sales Consistency Failure',
    props<{ error: string }>()
);
